import TimePickerController from './time-picker.controller';
import { TimePickerComponentProps } from './time-picker.model';

const TimePicker = (props: TimePickerComponentProps) => {
  return <TimePickerController {...props} />;
};

export default TimePicker;
